import $ from 'jquery';
import { observeIntersections } from '../../util/intersection/async.js';
import { getOptionsFromDataset } from '../../util/dom.js';
// import { triggerEvent } from '../../util/dom.js';

/**
 * @param {string} type
 * @param {Function} callable
 * @param {JQuery} $element
 * @param {...any} args
 */
const callCallable = (type, callable, $element, ...args) => {
	try {
		return callable($element, ...args);
	}
	catch (error) {
		console.error(`Error calling data-trigger-${type} callable for element:`, $element[0], error);
	}
};

/**
 * @param {JQuery} $element
 * @param {Function} callable
 */
const handleElementLoad = ($element, callable) => {
	callCallable('load', callable, $element);
};

/**
 * @param {JQuery} $element
 * @param {Function} callable
 */
const handleElementView = ($element, callable, options = {}) => {
	observeIntersections($element[0], false, {
		threshold: [0.25],
		...options,
	}, (entry) => {
		if (entry.isIntersecting) {
			callCallable('view', callable, $element, entry);
			return true;
		}
		return false;
	});
};

/**
 * @param {JQuery} $element
 * @param {Function} callable
 */
const handleElementIntersect = ($element, callable, options = {}) => {
	observeIntersections($element[0], true, options, entry => (callCallable('intersect', callable, $element, entry) === true ? true : false));
};

/**
 * @param {JQuery} $element
 * @param {Function} callable
 */
const handleElementClick = ($element, callable) => {
	$element.on('click.data-events', (event) => {
		callCallable('click', callable, $element, event);
	});
};

/**
 * @param {JQuery} $element
 * @param {Function} callable
 */
const handleElementChange = ($element, callable) => {
	$element.on('change.data-events', (event) => {
		callCallable('change', callable, $element, event);
	});
};

/**
 * @param {JQuery} $element
 * @param {Function} callable
 */
const handleElementSubmit = ($element, callable) => {
	$element.on('submit.data-events', (event) => {
		callCallable('submit', callable, $element, event);
	});
};

/**
 * Process special actions bound on form or form elements
 *
 * @param {JQuery<HTMLElement>|HTMLElement} container
 *
 * @returns {void}
 */
mpro.handleTriggerEventElements = (container) => {

	/** @type {JQuery} */
	// @ts-ignore
	const $container = (container instanceof $) ? container : $(container);
	const $actionTriggers = $container.find('[data-trigger-load],[data-trigger-view],[data-trigger-intersect],[data-trigger-click],[data-trigger-change],[data-trigger-submit]');

	for (const element of $actionTriggers) {

		const $element = $(element);
		const {
			triggerLoad,
			triggerView,
			triggerIntersect,
			triggerClick,
			triggerChange,
			triggerSubmit,
		} = element.dataset;

		if (triggerLoad) {
			handleElementLoad($element, window[triggerLoad]);
		}

		if (triggerView) {
			const options = getOptionsFromDataset(element, 'triggerView');
			handleElementView($element, window[triggerView], options);
		}

		if (triggerIntersect) {
			const options = getOptionsFromDataset(element, 'triggerIntersect');
			handleElementIntersect($element, window[triggerIntersect], options);
		}

		if (triggerClick) {
			handleElementClick($element, window[triggerClick]);
		}

		if (triggerChange) {
			handleElementChange($element, window[triggerChange]);
		}

		if (triggerSubmit) {
			handleElementSubmit($element, window[triggerSubmit]);
		}
	}
};

// Add init function that is executed on every page/fragment render
mpro.addInitStatic(($container) => {
	mpro.handleTriggerEventElements($container);
});

export default mpro;
